import { toast } from "react-toastify";
import Layout from "../../../components/Layout";
import { useMediaQuery } from "@mui/material";
import { httprequest } from "../../../data/api";
import { useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import useStyles from "../styles";
import nosearch from "../../../assets/images/no-search.svg";
import NotFounditem from "../../error/NotFound";
import PageTitle from "../../../components/PageTitle";
import * as XLSX from "xlsx";

const CLASSES_ENDPOINT = "/api/v1/class";
const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_CLASS_GRADES = "/api/v1/session-report/class/";
// const REPORT_ENDPOINT = "/api/v1/session-report/class";

const SessionReport = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [classGrades, setClassGrades] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  // const [reportData, setReportData] = useState([]);
  const navigate = useNavigate();

  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const handleGetAllClassResult = async (classID, sessionID) => {
    if (!classID) return;

    setIsPageFetching(true);
    try {
      let url = `${GET_CLASS_GRADES}${classID}`;
      if (sessionID) {
        url += `?session_id=${sessionID}`;
      }
      const res = await httprequest.get(url);
      setIsPageFetching(false);
      setClassGrades(res?.data?.data);
      setFilteredStudents(res?.data?.data);
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.message);
    }
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);

    handleGetAllClassResult(classId, activeSession?.id);
  };
  const allTerms = Array.from(
    new Map(
      (filteredStudents || [])
        .flatMap((s) => (s.subjects || []))
        .flatMap((subj) => (subj.terms || []))
        .map((term) => [term.id, { id: term.id, name: term.name }])
    ).values()
  );

  const handleSessionChange = (e) => {
    const sessionId = e.target.value;
    const selectedSession = allSessions.find(sesh => String(sesh.id) === String(sessionId));
    setActiveSession(selectedSession);
    if (selectedClass) {
      handleGetAllClassResult(selectedClass, sessionId);
    }
  };

  const columns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Student Name</p>}
          {row.first_name} {row.last_name}
        </>
      )
    },

    ...allTerms.map((term) => ({
      name: term.name,
      selector: (row) => {
        const scores = row.subjects
          .flatMap((subject) => subject.terms || [])
          .filter((t) => t.id === term.id)
          .map((t) => t.score);

        const avg =
        scores.length > 0
          ? (scores.reduce((acc, curr) => acc + curr, 0) / scores.length).toFixed(1)
          : "N/A";

        return (
          <>
            {isMobile && <p className="mobile-styling">{term.name}</p>}
            {avg}
          </>
        );
      }
    })),

    {
      name: "Session Average",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Session Average</p>}
          {row?.session_average?.toFixed(1) || "--/--"}
        </>
      )
    },

    {
      name: "Grade",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Grade</p>}
          {row.session_grade || "-//-" }
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate(`/reports/studentreport/${row.student_id}`)}>
            <Icon icon="hugeicons:view" />
          </button>
        </div>
      )
    }
  ];

  const exportToExcel = () => {
    if (classGrades.length === 0) {
      toast.warning("No data to export");

      return;
    }

    try {
      const exportData = classGrades.map(student => {
        const rowData = {
          "Student Name": `${student.first_name} ${student.last_name}`
        };

        // Add term scores
        allTerms.forEach(term => {
          const scores = student.subjects
            .flatMap((subject) => subject.terms || [])
            .filter((t) => t.id === term.id)
            .map((t) => t.score);

          const avg = scores.length > 0
            ? (scores.reduce((acc, curr) => acc + curr, 0) / scores.length).toFixed(1)
            : "N/A";

          rowData[term.name] = avg;
        });

        rowData["Session Average"] = student?.session_average?.toFixed(1) || "N/A";
        rowData["Grade"] = student.session_grade || "-//-";

        return rowData;
      });

      const ws = XLSX.utils.json_to_sheet(exportData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Session Report");

      const fileName = `Session_Report_${activeSession?.session || ""}_${new Date().toISOString().slice(0, 10)}.xlsx`;

      XLSX.writeFile(wb, fileName);

      toast.success("Report exported successfully!");
    } catch (error) {
      toast.error("Failed to export report");
    }
  };
  useEffect(() => {
    getAllClasses();
    getAllSessions();
    handleGetAllClassResult();
  }, []);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Session Report"
          subtitle="See all the result in the Session."
        />
        <div className="breadcrumb-container">
          <div className="flex gap-10">
            <div>
              {allSessions && allSessions.length > 0 && (
                <SelectGroup
                  children={
                    <select
                      value={activeSession?.id || ""}
                      onChange={handleSessionChange}
                      name="session"
                    >
                      <option value="">---Select---</option>
                      {allSessions?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </div>
            <div>
              <SelectGroup
                children={
                  <select onChange={handleClassChange} name="term" value={selectedClass}>
                    <option value="">--All Class--</option>
                    {classesData?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.class_name}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            </div>
          </div>
        </div>

        <div className="page-content margin-top-30">
          {isPageFetching ? (
            <PageLoader />
          ) : classGrades.length === 0 ? (
            <div className={classes.notfound}>
              <NotFounditem
                img={nosearch}
                title="No Session Report Found"
                subtitle="No Report has been added to the Class."
              />
            </div>
          ) : (
            <>
              <Table
                data={classGrades}
                columns={columns}
                subHeader={false}
                pagination
              />

              <div className="flex gap-10 margin-top-30">
                <Button
                  variant="primaryoutline"
                  buttonSize="medium"
                  color="btnfontprimary"
                  buttonName="Export Report"
                  onClick={exportToExcel}
                />
              </div>
            </>

          )}
        </div>
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default SessionReport;
